import { Component, HostListener, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { DeviceManagerService } from './core/services/device-manager.service';

import * as Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import { ReportBase } from './sections/reports/report-base';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit
{
	aiVisible = false;
	title = 'MyAppPortalV3';
	headerLoading = false;

	@HostListener('window:resize')
	onResize() {
		// Set up the host listener to listen for resize events to trigger hiding/showing
		// of hamburger menu and responsive design of navigation pane.
		this.deviceManager.windowResize.next({ width: window.innerWidth, height: window.innerHeight });
	}

	constructor(private deviceManager: DeviceManagerService,
	            private primengConfig: PrimeNGConfig) {}

	ngOnInit(): void
	{
		this.primengConfig.ripple = true;

		Highcharts.setOptions({
			colors: ReportBase.REPORT_OPTIONS.GRAPH_COLORS
		});
		HC_more(Highcharts);
	}

	handleAIChanging()
	{
		this.aiVisible = !this.aiVisible;
	}
}
